/**
 * Проверка наличия обязательных переменных окружения
 * Вызывается при старте приложения
 */
export const checkEnvVars = () => {
    const required = [
        'REACT_APP_SUPABASE_URL',
        'REACT_APP_SUPABASE_ANON_KEY',
        'REACT_APP_MAPBOX_TOKEN',
    ];
    
    const missing = required.filter(key => !process.env[key]);
    
    if (missing.length > 0) {
        const isProduction = process.env.NODE_ENV === 'production';
        
        if (isProduction) {
            // В production выбрасываем ошибку
            throw new Error(
                `❌ Отсутствуют обязательные переменные окружения: ${missing.join(', ')}\n` +
                `Пожалуйста, настройте .env файл перед запуском в production.`
            );
        } else {
            // В development только предупреждаем
            console.warn(
                `⚠️ Отсутствуют переменные окружения: ${missing.join(', ')}\n` +
                `Некоторые функции могут работать некорректно.`
            );
        }
    }
};
